module.exports = __webpack_public_path__ + "img/products_big_can_pomegranate.2f2faf15.png";